import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Typography,
  Table,
  Space,
  Spin,
  Card
} from "antd";
import { Popup } from "../../atoms/Popup";
import SectionHeader from "../../molecules/SectionHeader";
import { useSelector, useDispatch } from "react-redux";

import AddShift from "./components/AddShift";



import { getAllShifts, assignDefault, setSelectedProvider, fetchCenters, setSelectedCenter, fetchProviders, fetchEmptyProviders, fetchEmptyCenters, getEmptyShifts } from "./ducks/actions";
import { ReactSelectField } from "../../atoms/FormElement";

import { useForm } from "react-hook-form";
import AddOperatingHours from "./components/AssignShift/AddOperatingHours";
import { HolidayForm, HolidayCalendar } from "./components/Holidays";

import _ from "lodash";
const { Title } = Typography;

export default () => {
  const dispatch: any = useDispatch();
  const selectedCompany = useSelector((state: any) => state.calendar.selectedCompany);

  const providers = useSelector((state: any) => state.calendar.providers);
  const centers = useSelector((state: any) => state.calendar.centers);

  const selectedCenter = useSelector((state: any) => state.calendar.selectedCenter);
  const selectedProvider = useSelector((state: any) => state.calendar.selectedProvider);
  const shiftsApi = useSelector((state: any) => state.calendar.shiftData);


  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [shiftData, setshiftData] = useState(null);
  const [loader, setLoader] = useState(false);

  const defaultVal = {
    provider: '',
    center: ''
  };
  const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm({
    defaultValues: defaultVal,
  });


  const assignTechCol = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      // width: 220,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      // width: 220,
    },
    {
      title: "Slots",
      dataIndex: "shifts",
      key: "Breaks",
      // width: 220,
      render: (text, data) => {
        const slots = data?.shifts?.length
        return slots;
      }
    },
  ];


  useEffect(() => {
    if (selectedCompany) {
      dispatch(fetchProviders(selectedCompany));
      dispatch(fetchEmptyCenters());
      dispatch(fetchEmptyProviders())
      setValue('provider', '');
      setValue('center', '');
    }

    return () => {
      dispatch(fetchEmptyCenters());
      dispatch(fetchEmptyProviders())
    };
  }, [selectedCompany]);

  useEffect(() => {
    if (selectedProvider && selectedCenter)
      dispatch(getAllShifts({ selectedProvider: selectedProvider, selectedCenter: selectedCenter }));
    else
      dispatch(getEmptyShifts());

    return () => dispatch(getEmptyShifts());
  }, [selectedProvider, selectedCenter]);

  const onSubmit = () => {
    (selectedProvider && selectedCenter)
      && dispatch(getAllShifts({ selectedProvider: selectedProvider, selectedCenter: selectedCenter }));
    setVisible(false);
  };

  const popup = [
    {
      title: (
        <Title level={3} className=" mb-0">
          Add New Shift
        </Title>
      ),
      content: (
        <AddShift
          // onAddTech={onAddTech}
          // onAddShift={onAddShift}
          data={shiftData}
          onCancel={() => setVisible(false)}
          onSubmit={onSubmit}
        />
      ),
      width: 700,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    onCancel: () => setVisible(false),
  };

  const AddNewShift = () => {
    setshiftData({});
    setVisible(true);
    setTrigger(0);
  };


  const handleProviderChange = (selectedOption) => {
    setValue('center', '');
    dispatch(setSelectedCenter(''));
    dispatch(setSelectedProvider(selectedOption));
    dispatch(fetchCenters(selectedCompany, selectedOption));
  };

  const handleCenterChange = (selectedOption) => {
    dispatch(setSelectedCenter(selectedOption));
  };

  useEffect(() => {
    if (shiftData) {
      setVisible(true);
    }
  }, [shiftData])

  return (
    <>
      {loader && (
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Space size={24} className="w-100 text-center" direction="vertical">
              <Spin size="large" className="ag-fontSize32" />
              {/* <Paragraph className="ag-default fontWeight600 mb-0">Loading</Paragraph> */}
            </Space>
          </Col>
        </Row>
      )}
      <Row gutter={24}>
        <Col span={24}>
          <SectionHeader heading="Configuration" />
          <Col span={24} style={{ padding: 0 }}>
            <Row>
              <Col span={8}>
                <ReactSelectField
                  fieldname="provider"
                  label="Category"
                  control={control}
                  iProps={{
                    placeholder: "Select category",
                    isDisabled: !providers?.length,
                  }}
                  selectOption={providers}
                  onChange={handleProviderChange}
                />
              </Col>

              <Col span={10}>
                <ReactSelectField
                  fieldname="center"
                  label={<>&nbsp; Center</>}
                  control={control}
                  iProps={{
                    placeholder: "Choose Center",
                    isDisabled: !centers?.length,
                  }}
                  selectOption={centers}
                  onChange={handleCenterChange}
                />
              </Col>
            </Row>
          </Col>
          <Row>
            <Col span={24}>
              {/* <Row gutter={[20, 20]} justify="end"> */}
              <AddOperatingHours isDisabled={!(selectedCompany && selectedProvider)} providerData={selectedCenter} onCancel={() => setVisible(false)} onSubmit={onSubmit} />
              {/* </Row> */}
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <SectionHeader
            heading="Shifts"
            isDisabled={!(selectedCompany && selectedProvider)}
            addNewAction={AddNewShift}
          />
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Row gutter={[20, 20]} justify="end">
                <Col span={24}>
                  <Table
                    columns={assignTechCol}
                    scroll={{ y: 500 }}
                    // rowKey={(record, index) => index}
                    dataSource={(shiftsApi && shiftsApi?.shifts?.length > 0) ? shiftsApi?.shifts : []}
                    // rowSelection={rowSelection}
                    className="custom-table org_table_wrap"
                    pagination={false}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        <Col span={24} style={{ marginTop: '30px'}}>
          <SectionHeader heading="Holiday" />
          <Card
            bordered={false}
            // bodyStyle={{ padding: "0 32px 42px" }}
            styles={{ header: { padding: "0 32px", borderBottom: 0 } }}
            className="operating-hours"
            title={<Title level={3} className="mb-0">Add Holidays </Title>}>
            <Row>
              <Col span={14}>
                <HolidayForm providerData={selectedCenter} />
              </Col>
              <Col span={10}>
                <HolidayCalendar providerData={selectedCenter} />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <br/><br/>
      <Popup destroyOnClose={true} {...popupProps} />
    </>
  );
};
